module.exports = __webpack_public_path__ + "img/Search-Icon.a6c22173.svg";